async function getAnexoFromUrl(caminhoArquivo, nomeArquivo) {
    const baseURL = `${window._env_?.REACT_APP_URL}`;

    const urlArquivo = caminhoArquivo.startsWith("http")
        ? caminhoArquivo
        : `${baseURL}/${caminhoArquivo.replace(/^\/+/, "")}`;

    const response = await fetch(urlArquivo, {
        credentials: "include"
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar arquivo: ${response.status} - ${response.statusText}`);
    }

    const blob = await response.blob();

    const file = new File(
        [blob],
        nomeArquivo,
        { type: blob.type || "application/octet-stream" }
    );

    return {
        anexo: file,
        nome: nomeArquivo
    };
}

export default getAnexoFromUrl;